
    <ng-content></ng-content>
  


// WEBPACK FOOTER //
// ./node_modules/@swimlane/ngx-datatable/release/components/body/selection.component.d.ts.DataTableSelectionComponent.html